import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import NotFound from '../views/NotFound.vue'
import NotAuthorized from '../views/NotAuthorized.vue'
import Aide from '../views/aide/Aide.vue'
import AideSection from '../views/aide/Aide-section.vue'
import Entreprise from '../views/entreprise/Entreprise.vue'
import Marche from '../views/marche/Marche.vue'
import EmpreinteEconomique from '../views/empreinte-economique/EmpreinteEconomique.vue'
import CreerEmpreinteEconomique from '../views/empreinte-economique/CreerEmpreinteEconomique.vue'
import CreerMarche from '../views/marche/CreerMarche.vue'
import RechercherMarche from '../views/marche/RechercherMarche.vue'
import CreerEntrepriseMarcheInfos from '../views/entreprise-marche-infos/CreerEntrepriseMarcheInfos.vue'
import RechercherEntreprise from '../views/entreprise/RechercherEntreprise.vue'
import CreerEntreprise from '../views/entreprise/CreerEntreprise.vue'
import Utilisateurs from '../views/utilisateur/Utilisateur.vue'
import RechercherUtilisateur from '../views/utilisateur/RechercherUtilisateur.vue'
import CreerUtilisateur from '../views/utilisateur/CreerUtilisateur.vue'
import ListerEmpreinte from '../views/empreinte-economique/ListerEmpreinte.vue'
import VerifierEmpreinte from '../views/empreinte-economique/VerifierEmpreinte.vue'
import ImporterEmpreinte from '../views/empreinte-economique/ImporterEmpreinte.vue'
import MarcheEffectifInfos from '../views/marche-effectif-infos/MarcheEffectifInfos.vue'
import CreerMarcheEffectifInfos from '../views/marche-effectif-infos/CreerMarcheEffectifInfos.vue'
import ListerMarcheEffectifInfos from '../views/marche-effectif-infos/ListerMarcheEffectifInfos.vue'
import VerifierMarcheEffectifInfos from '../views/marche-effectif-infos/VerifierMarcheEffectifInfos.vue'
import MarcheSecuriteChantiers from '../views/marche-securite-chantiers/MarcheSecuriteChantiers.vue'
import CreerMarcheSecuriteChantiers from '../views/marche-securite-chantiers/CreerMarcheSecuriteChantiers.vue'
import ListerMarcheSecuriteChantiers from '../views/marche-securite-chantiers/ListerMarcheSecuriteChantiers.vue'
import VerifierMarcheSecuriteChantiers from '../views/marche-securite-chantiers/VerifierMarcheSecuriteChantiers.vue'
import AdministrationGpec from '../views/gpec/AdministrationGpec.vue'
import VerifierCodeRome from '../views/code-rome/VerifierCodeRome.vue'
import GpecSynthesePrevisionnel from '../views/gpec/previsionnel/GpecSynthesePrevisionnel.vue'
import CreerGpecSynthesePrevisionnel from '../views/gpec/previsionnel/CreerGpecSynthesePrevisionnel.vue'
import ListerGpecSynthesePrevisionnel from '../views/gpec/previsionnel/ListerGpecSynthesePrevisionnel.vue'
import VerifierGpecSynthesePrevisionnel from '../views/gpec/previsionnel/VerifierGpecSynthesePrevisionnel.vue'
import GpecSyntheseRealise from '../views/gpec/realise/GpecSyntheseRealise.vue'
import CreerGpecSyntheseRealise from '../views/gpec/realise/CreerGpecSyntheseRealise.vue'
import ListerGpecSyntheseRealise from '../views/gpec/realise/ListerGpecSyntheseRealise.vue'
import VerifierGpecSyntheseRealise from '../views/gpec/realise/VerifierGpecSyntheseRealise.vue'
import ImporterReferenceFormation from '../views/reference-formation/ImporterReferenceFormation.vue'
import ImporterEntreprise from '../views/entreprise/ImporterEntreprise.vue'
import Reporting from '../views/reporting/Reporting.vue'
import ReportingMensuel from '../views/reporting/ReportingMensuel.vue'
import ReportingTrimestriel from '../views/reporting/ReportingTrimestriel.vue'
import ReportingDispenses from '../views/reporting/ReportingDispenses.vue'
import Administration from '../views/administration/Administation'
import ImporterMarche from '../views/marche/ImporterMarche.vue'
import RechercherEntrepriseMarcheInfos from "@/views/entreprise-marche-infos/RechercherEntrepriseMarcheInfos.vue";


const routes = [
  {
    path: '/',
    name: 'Accueil',
    component: Home,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ALL'],
      icon: 'home',
      rootPage: true,
      spacerNext: true
    }
  },
  {
    path: '/empreinte-economique',
    name: 'Empreinte économique',
    component: EmpreinteEconomique,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_UTILISATEUR','CORRESPONDANT_EMPREINTE_LECTURE','CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'],
      icon: 'file-alt',
      rootPage: true
    },
    children: [
      {
        path: 'creation',
        name: 'Soumettre empreinte',
        component: CreerEmpreinteEconomique,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_UTILISATEUR','CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'],
        }
      },
      {
        path: 'consultation',
        name: 'Consulter empreintes',
        component: ListerEmpreinte,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_UTILISATEUR','CORRESPONDANT_EMPREINTE_LECTURE','CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'],
        }
      },
      {
        path: 'validation',
        name: 'Approuver empreintes',
        component: VerifierEmpreinte,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR','CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'],
        }
      },
      {
        path: 'excel',
        name: 'Interface Excel',
        component: ImporterEmpreinte,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_UTILISATEUR','CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'],
        }
      },
      {
        path: ':id',
        name: 'Modifier empreinte',
        component: CreerEmpreinteEconomique,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_UTILISATEUR','CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'],
          hideFromSubpages: true
        }
      }
    ]
  },
  {
    path: '/marche-effectif-infos',
    name: 'Effectifs',
    component: MarcheEffectifInfos,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_UTILISATEUR','CORRESPONDANT_EFFECTIFS_LECTURE','CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
      icon: 'chart-bar',
      rootPage: true
    },
    children: [
      {
        path: 'creation',
        name: 'Soumettre données d\'effectifs',
        component: CreerMarcheEffectifInfos,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_UTILISATEUR','CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
        }
      },
      {
        path: 'consultation',
        name: 'Consulter données d\'effectifs',
        component: ListerMarcheEffectifInfos,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_UTILISATEUR','CORRESPONDANT_EFFECTIFS_LECTURE','CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
        }
      },
      {
        path: 'validation',
        name: 'Approuver données d\'effectifs',
        component: VerifierMarcheEffectifInfos,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR','CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
        }
      },
      {
        path: ':id',
        name: 'Modifier données d\'effectifs',
        component: CreerMarcheEffectifInfos,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_UTILISATEUR','CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
          hideFromSubpages: true
        }
      }
    ]
  },
  {
    path: '/marche-securite-chantiers',
    name: 'Accidentologie',
    component: MarcheSecuriteChantiers,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_UTILISATEUR', 'CORRESPONDANT_SECURITE_LECTURE', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR'],
      icon: 'hard-hat',
      rootPage: true
    },
    children: [
      {
        path: 'creation',
        name: 'Soumettre données d\'accidentologie',
        component: CreerMarcheSecuriteChantiers,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_UTILISATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR'],
        }
      },
      {
        path: 'consultation',
        name: 'Consulter données d\'accidentologie',
        component: ListerMarcheSecuriteChantiers,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_UTILISATEUR', 'CORRESPONDANT_SECURITE_LECTURE', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR'],
        }
      },
      {
        path: 'validation',
        name: 'Approuver données d\'accidentologie',
        component: VerifierMarcheSecuriteChantiers,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR'],
        }
      },
      {
        path: ':id',
        name: 'Modifier données d\'accidentologie',
        component: CreerMarcheSecuriteChantiers,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_UTILISATEUR','CORRESPONDANT_SECURITE_ADMINISTRATEUR'],
          hideFromSubpages: true
        }
      }
    ]
  },
  {
    path: '/gpec-besoins-previsionnels',
    name: 'GPEC - Besoins prév.',
    component: GpecSynthesePrevisionnel,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR', 'CORRESPONDANT_GPEC_LECTURE', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
      icon: 'user-plus',
      rootPage: true
    },
    children: [
      {
        path: 'creation',
        name: 'Soumettre synthèse prévisionnel',
        component: CreerGpecSynthesePrevisionnel,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          title: 'Soumettre un nouveau formulaire',
        }
      },
      {
        path: 'consultation',
        name: 'Consulter synthèses prévisionnel',
        component: ListerGpecSynthesePrevisionnel,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR', 'CORRESPONDANT_GPEC_LECTURE', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          title: 'Consulter l\'historique'
        }
      },
      {
        path: 'validation',
        name: 'Approuver synthèses prévisionnel',
        component: VerifierGpecSynthesePrevisionnel,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          title: 'Valider les demandes'
        }
      },
      {
        path: ':id',
        name: 'Modifier synthèse prévisionnel',
        component: CreerGpecSynthesePrevisionnel,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR','CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          hideFromSubpages: true,
          title: 'Formulaire',
        }
      }
    ]
  },
  {
    path: '/gpec-bilan-trimestriel',
    name: 'GPEC - Bilan trimestriel',
    component: GpecSyntheseRealise,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR', 'CORRESPONDANT_GPEC_LECTURE', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
      icon: 'id-card-alt',
      rootPage: true
    },
    children: [
      {
        path: 'creation',
        name: 'Soumettre synthèse réalisé',
        component: CreerGpecSyntheseRealise,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          title: 'Soumettre un nouveau formulaire',
        }
      },
      {
        path: 'consultation',
        name: 'Consulter synthèses réalisé',
        component: ListerGpecSyntheseRealise,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR', 'CORRESPONDANT_GPEC_LECTURE', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          title: 'Consulter l\'historique'
        }
      },
      {
        path: 'validation',
        name: 'Approuver synthèses réalisé',
        component: VerifierGpecSyntheseRealise,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          title: 'Valider les demandes'
        }
      },
      {
        path: ':id',
        name: 'Modifier synthèse réalisé',
        component: CreerGpecSyntheseRealise,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR','CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          hideFromSubpages: true,
          title: 'Formulaire',
        }
      }
    ]
  },
  {
    path: '/entreprises',
    name: 'Ref. Entreprises',
    component: Entreprise,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_UTILISATEUR','CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'],
      icon: 'building',
      rootPage: true,
      spacerBefore: true
    },
    children: [
      {
        path: 'creation',
        name: 'Créer une entreprise',
        component: CreerEntreprise,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_UTILISATEUR','CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'],
        }
      },
      {
        path: 'recherche',
        name: 'Rechercher une entreprise',
        component: RechercherEntreprise,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR'],
        }
      },
      {
        path: 'import',
        name: 'Importer entreprises',
        component: ImporterEntreprise,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR']
        }
      },
      {
        path: ':id',
        name: 'Modifier entreprise',
        component: CreerEntreprise,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR'],
          hideFromSubpages: true
        }
      },
    ]
  },
  {
    path: '/marches',
    name: 'Ref. Marchés',
    component: Marche,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR'],
      icon: 'landmark',
      rootPage: true
    },
    children: [
      {
        path: 'creation',
        name: 'Créer un marché',
        component: CreerMarche,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR'],
        }
      },
      {
        path: 'recherche',
        name: 'Rechercher un marché',
        component: RechercherMarche,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR'],
        }
      },
      {
        path: 'import',
        name: 'Importer un marché',
        component: ImporterMarche,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR'],
         }
       },
      {
        path: 'entreprise-marche-infos',
        name: 'Entreprise / marché infos',
        component: CreerEntrepriseMarcheInfos,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR'],
        }
      },
      {
        path: 'recherche-entreprise-marche-infos',
        name: 'Rechercher entreprise / marché infos',
        component: RechercherEntrepriseMarcheInfos,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR'],
        }
      },
      {
        path: ':id',
        name: 'Modifier marché',
        component: CreerMarche,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR'],
          hideFromSubpages: true
        }
      }
    ]
  },
  {
    path: '/referentiels-gpec',
    name: 'Ref. GPEC',
    component: AdministrationGpec,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
      icon: 'list-alt',
      rootPage: true
    },
    children: [
      {
        path: 'validation-codes-romes',
        name: 'Gérer les postes ajoutés à la synthèse',
        component: VerifierCodeRome,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
        }
      },
      {
        path: 'referentiel-formations',
        name: 'Référentiel des formations',
        component: ImporterReferenceFormation,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
        }
      }
    ]
  },
  {
    path: '/reporting',
    name: 'Suivi du reporting',
    component: Reporting,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
      icon: 'clipboard-list',
      rootPage: true
    },
    children: [
      {
        path: 'mensuel',
        name: 'Mensuel',
        component: ReportingMensuel,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
        }
      },
      {
        path: 'trimestriel',
        name: 'Trimestriel',
        component: ReportingTrimestriel,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
        }
      },
      {
        path: 'dispenses',
        name: 'Dispenses',
        component: ReportingDispenses,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
        }
      },
    ]
  },
  {
    path: '/utilisateurs',
    name: 'Utilisateurs',
    component: Utilisateurs,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
      icon: 'users',
      rootPage: true
    },
    children: [
      {
        path: 'creation',
        name: 'Créer utilisateur',
        component: CreerUtilisateur,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
        }
      },
      {
        path: 'recherche',
        name: 'Rechercher utilisateur',
        component: RechercherUtilisateur,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
        }
      },
      {
        path: ':id',
        name: 'Modifier utilisateur',
        component: CreerUtilisateur,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
          hideFromSubpages: true
        }
      }
    ]
  },
  {
    path: '/administration',
    name: 'Administration',
    component: Administration,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ADMINISTRATEUR'],
      icon: 'user-shield',
      rootPage: true
    }
  },
  {
    path: '/aide',
    name: 'Aide',
    component: Aide,
    meta: {
      authenticationRequired: true,
      allowedRoles: ['ALL'],
      icon: 'info-circle',
      rootPage: true,
      spacerBefore: true
    },
    children: [
      {
        path: 'intro',
        name: 'Aide intro',
        component: AideSection,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ALL'],
          title: 'Présentation générale',
          aide_title: 'Présentation générale',
          aide_file: 'SGS_S-Print_guide_utilisateur_presentation.pdf'
        }
      },
      {
        path: 'ecrans-menus',
        name: 'Aide Écrans & menus',
        component: AideSection,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ALL'],
          title: 'Écrans & menus',
          aide_title: 'Écrans & menus',
          aide_file: 'SGS_S-Print_guide_utilisateur_ecrans_et_menu.pdf'
        }
      },
      {
        path: 'empreinte-economique',
        name: 'Aide empreinte économique',
        component: AideSection,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EMPREINTE_UTILISATEUR', 'CORRESPONDANT_EMPREINTE_LECTURE', 'CORRESPONDANT_EMPREINTE_ADMINISTRATEUR'],
          title: 'Empreinte Economique',
          aide_title: 'Empreinte Economique',
          aide_file: 'SGS_S-Print_guide_utilisateur_empreinte_economique.pdf'
        }
      },
      {
        path: 'marche-effectif-infos',
        name: 'Aide Effectifs',
        component: AideSection,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_EFFECTIFS_UTILISATEUR', 'CORRESPONDANT_EFFECTIFS_LECTURE', 'CORRESPONDANT_EFFECTIFS_ADMINISTRATEUR'],
          title: 'Effectifs',
          aide_title: 'Effectifs',
          aide_file: 'SGS_S-Print_guide_utilisateur_effectifs.pdf'
        }
      },
      {
        path: 'marche-securite-chantiers',
        name: 'Aide Accidentologie',
        component: AideSection,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_SECURITE_UTILISATEUR', 'CORRESPONDANT_SECURITE_LECTURE', 'CORRESPONDANT_SECURITE_ADMINISTRATEUR'],
          title: 'Accidentologie',
          aide_title: 'Accidentologie',
          aide_file: 'SGS_S-Print_guide_utilisateur_accidentologie.pdf'
        }
      },
      {
        path: 'gpec-besoins-previsionnels',
        name: 'Aide GPEC - Besoins prévisionnels',
        component: AideSection,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR', 'CORRESPONDANT_GPEC_LECTURE', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          title: 'GPEC - Besoins prévisionnels',
          aide_title: 'GPEC - Besoins prévisionnels',
          aide_file: 'SGS_S-Print_guide_utilisateur_GPEC_previsionnel.pdf'
        }
      },
      {
        path: 'gpec-bilan-trimestriel',
        name: 'Aide GPEC - Bilan trimestriel',
        component: AideSection,
        meta: {
          authenticationRequired: true,
          allowedRoles: ['ADMINISTRATEUR', 'CORRESPONDANT_GPEC_UTILISATEUR', 'CORRESPONDANT_GPEC_LECTURE', 'CORRESPONDANT_GPEC_ADMINISTRATEUR'],
          title: 'GPEC - Bilan trimestriel',
          aide_title: 'GPEC - Bilan trimestriel',
          aide_file: 'SGS_S-Print_guide_utilisateur_GPEC_realise.pdf'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      authenticationRequired: false
    }
  },
  {
    path: '/page-inaccessible',
    name: 'not-authorised',
    component: NotAuthorized,
    meta: {
      authenticationRequired: false
    }
  },
  {
    path: '*',
    alias: '/page-introuvable',
    name: 'not-found',
    component: NotFound,
    meta: {
      authenticationRequired: false
    }
  },
];

export default routes;
